import React, {useRef, useEffect, useState} from "react";
import './MushroomAi.scss';

import Header from "../../components/Header";
import Button from "react-bootstrap/Button";
import mapboxgl from 'mapbox-gl'

import 'mapbox-gl/dist/mapbox-gl.css';
import Footer from "../../components/Footer";
import {useModal} from "../../components/ModalContext";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import {format} from 'date-fns';

let img_play = require("../../assets/home/play-button-icon.png");
let img_top = require("../../assets/mushroom/26.webp");
let icon_trial = require("../../assets/mushroom/27.png");
let icon_show = require("../../assets/mushroom/28.png");


function MushroomAi() {
    const {openModal} = useModal();
    const mapRef = useRef()
    const mapContainerRef = useRef();
    const [showMap, setShowMap] = useState(false);
    const [position, setPosition] = useState([]);
    const [lastUpdate, setLastUpdate] = useState(format(new Date(), 'dd/MM/yyyy HH:mm'));
    const [images, setImages] = useState([]);
    const [zoom, setZoom] = useState(5);


    useEffect(() => {
        mapboxgl.accessToken = 'pk.eyJ1IjoiZ2VvdGlja2V0c3JsIiwiYSI6ImNsenFvcmh1dzF0bDgyanFyd3lhaGhtNWMifQ.Lt-gOko0rO-VuTBu3kKD1w'
        mapRef.current = new mapboxgl.Map({
            container: mapContainerRef.current,
            center: [12.2558141, 41.9097306],
            zoom: 5
        });

        return () => {
            mapRef.current.remove()
        }
    }, []);

    useEffect(() => {
        if (!mapRef) return;

        const updateZoom = () => {
            console.log("mapRef.current.getZoom().toFixed(2)")
            console.log(mapRef.current.getZoom().toFixed(2))
            let z = mapRef.current.getZoom().toFixed(2);
            if (z > 7)
                setZoom(11);
            else
                setZoom(5);
        }
        const fullscreenControl = new mapboxgl.FullscreenControl({
            container: document.querySelector('#map-container'), // opzionale
        });

        if (showMap)
            mapRef.current.addControl(fullscreenControl, 'top-right');

        mapRef.current.on('zoom', updateZoom);
        updateZoom();

        return () => mapRef.current.off('zoom', updateZoom);
    }, [mapRef, showMap]);

    useEffect((position) => {
        fetch(global.route.ai_map, {
            method: 'POST',
            credentials: 'include',
        }).then((response) => {
            if (response.status === 200) {
                response.json().then(async response => {
                    setLastUpdate(response.last_update);
                    setPosition(position);
                    setImages(response.list);
                    console.log(response);
                });
            } else
                global.catchError(response)
        });
    }, [position])

    useEffect(() => {
        if (!mapRef) return;
        for (let type in images) {
            for (let key in images[type][zoom]) {
                let item = images[type][zoom][key];
                const sourceId = `imageSource-${item.id}`;
                const layerId = `rasterSource-${item.id}`;

                if (mapRef.current.getSource(sourceId)) return; // evita duplicati

                mapRef.current.addSource(sourceId, {
                    type: 'image',
                    url: `${global.route.ai_srv}${item.image}`,
                    coordinates: [
                        [item.lon_start, item.lat_end],
                        [item.lon_end, item.lat_end],
                        [item.lon_end, item.lat_start],
                        [item.lon_start, item.lat_start],
                    ],
                });

                mapRef.current.addLayer({
                    id: layerId,
                    type: 'raster',
                    source: sourceId,
                    paint: {
                        'raster-opacity': 0.4,
                    },
                });
            }
        }
    }, [mapRef, zoom, images]);

    return (
        <div style={{backgroundColor: "#fafafa"}} className={"mushroom-ai-container"}>
            <Header/>
            <div className="video-section">
                <img className="background-video" src={img_top}/>

                <div className="overlay-content background">
                    <div>
                        <img className={"image-play"} src={img_play} alt="Card image cap"
                             onClick={() => openModal("video-ai")}/>
                        <div className={"container"}>
                            <div style={{flex: 1}}>
                                <h1 className="title">Benvenuto nella<br/>
                                    <b>Tabella Crescite <span className={"orange"}>Intelligente</span></b></h1>
                            </div>
                            <h4>La Tabella Crescite Intelligente incrocia migliaia di dati ambientali
                                per prevedere la crescita fungina.
                                Saprai in anticipo quando nasceranno, e dove.</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"container mt-4 mb-4"}>
                <div style={{width: '100%', height: 640, position: 'relative'}}>
                    <div id='map-container' className={"map"} ref={mapContainerRef}/>
                    <div className={"map-alert " + (!showMap ? "d-none" : "")}>
                        <span>Stai consultando la versione gratuita</span>
                        <span>Data della crescita fungina analizzata: {lastUpdate}</span>
                        <span className={"orange"}>Se vuoi sapere dove stanno nascendo oggi:</span>
                        <Button className={"btn-success"} href={"/premium"}>PROVA SUBITO LA VERSIONE COMPLETA</Button>
                    </div>
                    <div className={"map-overlay " + (showMap ? "d-none" : "")}>
                        <div className="map-container">
                            <span className={"title"}><b>Attenzione:</b> la Tabella Crescita Intelligente <span
                                className={"orange"}>aggiornata ad oggi</span> è disponibile solo per gli
                            utenti di Geoticket+</span>
                            <div className="button-group">
                                <div>
                                    <Button className={"btn-orange"} href={"/premium"}><img src={icon_trial}
                                                                                            alt="Card image cap"/> AVVIA
                                        LA TUA PROVA
                                        GRATUITA</Button>
                                </div>
                                <div>
                                    <Button className={"btn-success"} onClick={setShowMap}><img src={icon_show}
                                                                                                alt="Card image cap"/> CONSULTA
                                        COMUNQUE LA MAPPA
                                        (DATI NON
                                        AGGIORNATI)</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row"}>
                    <div className="col-md-6 mt-4">
                        <div className={"legend"}>
                            <b align={"center"}>Tabella crescita</b>
                            <p>La tabella crescite intelligente incrocia
                                in tempo reale milioni di dati fondamentali per stimare
                                la reale crescita fungina in Italia.</p>
                            <b align={"center"}>COME FUNZIONA</b>
                            <span align={"center"}>Dati analizzati in tempo reale:</span>
                            <ul>
                                <li>Tipo di forestazione locale (European Forest Genetic Program);</li>
                                <li>Specie arborea;</li>
                                <li>Temperatura locale;</li>
                                <li>Altitudine;</li>
                                <li>Piovosità attuale e calcolo cumulativo.</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-6 mt-4">
                        <div className={"legend"}>
                            <b align={"center"}>Legenda</b>
                            <ol>
                                <li>
                                    <div style={{
                                        borderRadius: 50,
                                        height: 24,
                                        width: 24,
                                        backgroundColor: "#FFEB3B"
                                    }}></div>
                                    <div style={{flex: 1}}>
                                        Area boschiva analizzata
                                    </div>
                                </li>
                                <li>
                                    <div style={{
                                        borderRadius: 50,
                                        height: 24,
                                        width: 24,
                                        backgroundColor: "#FF9800"
                                    }}></div>
                                    <div style={{flex: 1}}>
                                        Avvio della crescita fungiva
                                    </div>
                                </li>
                                <li>
                                    <div style={{
                                        borderRadius: 50,
                                        height: 24,
                                        width: 24,
                                        backgroundColor: "rgb(46, 125, 50)"
                                    }}></div>
                                    <div style={{flex: 1}}>
                                        Crescita fungina buona
                                    </div>
                                </li>
                                <li>
                                    <div style={{
                                        borderRadius: 50,
                                        height: 24,
                                        width: 24,
                                        backgroundColor: "rgb(41, 98, 255)",
                                    }}></div>
                                    <div style={{flex: 1}}>
                                        Crescita fungina eccezionale
                                    </div>
                                </li>
                                <li>
                                    <div style={{
                                        borderRadius: "50%",
                                        height: 24,
                                        width: 24,
                                        border: "4px solid #FFEB3B",
                                        transform: [{rotate: '-45deg'}]
                                    }}>
                                        <div style={{
                                            backgroundColor: "#FFEB3B", width: '100%',
                                            height: '50%'
                                        }}></div>
                                    </div>
                                    <div style={{flex: 1}}>
                                        Bordo del raggio di analisi: analizzati slot circolari di 5 km
                                    </div>
                                </li>
                                <li>
                                    <div style={{
                                        borderRadius: "50%",
                                        height: 24,
                                        width: 24,
                                        border: "4px solid #FFEB3B",
                                    }}></div>
                                    <div style={{flex: 1}}>
                                        No dati di crescita = assenza di precipitazioni. Ricontrolla in seguito.
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default MushroomAi;